var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(35 22 20)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.5 16.8 23.5 1-2 5.2h-21.5z",
  fill: "#b9c2c9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.5 23 1.5 2.1 1.5-2.1z",
  fill: "#b9c2c9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19 23 1.5 2.1 1.5-2.1z",
  fill: "#b9c2c9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.5 23 1.5 2.1 1.5-2.1z",
  fill: "#b9c2c9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28 23 1.5 2.1 1.5-2.1z",
  fill: "#b9c2c9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.5 23 1.5 2.1 1.5-2.1z",
  fill: "#b9c2c9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m8.5 15h5c1.7 0 3 1.3 3 3v4.5c0 1.7-1.3 3-3 3h-5c-1.7 0-3-1.3-3-3v-4.5c0-1.7 1.3-3 3-3zm0.5 2.6c-0.9 0-1.6 0.7-1.6 1.6v2c0 0.9 0.7 1.6 1.6 1.6h3.6c0.9 0 1.6-0.7 1.6-1.6v-2c0-0.9-0.7-1.6-1.6-1.6z",
  fill: "#b07845"
}));

function SvgCarpentryTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpentryTools);
export default __webpack_public_path__ + "static/media/carpentry-tools.ae0076d8cf718f5a9112889eb72c3d16.svg";
export { ForwardRef as ReactComponent };